import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../store/authProvider";

import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import {
  getInputs,
  getInputsCategories,
  getInputsFavorites,
  getStates,
} from "../../api";
import ContactModal from "../../components/contact_modal";
import FillterModal from "../../components/fillter_modal";
import LgSearch from "../../components/Lg_search";
import SmallSearch from "../../components/small_search";
import { cities_data, markets_data } from "../../data";
import Client from "../../utils/client";
import LoadingCircle from "../auction/component/loading";
import InputItem from "./components/item";
import DetailsModal from "./components/details-modal";
import { AnimatePresence } from "framer-motion";
import notFound from "../../images/not-found.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Skelton from "../../icons/skelton";
import PlaceOrderModal from "../../components/place_order_modal";

function InputsOffers() {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Inputs Offers",
  });
  const { isAuth } = useAuth();
  const [input, setInput] = useState();
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [state, setState] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [crop, setCrop] = useState([]);

  const [priceSort, setPriceSort] = useState(null);

  const { data: categories } = useQuery({
    queryKey: ["inputsCategories"],
    queryFn: () => getInputsCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const getInput = async (id) => {
    const response = await Client.get(`/inputs/${id}`).then((res) => res.data);
    setInput(response);
    setShowModal(true);
    const user_id = localStorage.getItem("user_id");
    Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action: "Product View",
      product_type: "Inputs Product",
      product_id: id.toString(),
    });
  };

  const onSubmit = (search) => {
    refetch();
  };

  const {
    data: inputs,
    isFetching,
    refetch,
    error,
  } = useQuery({
    queryKey: ["inputs", priceSort],
    queryFn: () =>
      getInputs(
        "sell",
        state.map((e) => e.value),
        crop.map((e) => e.value),
        getValues().search_word === ""
          ? getValues().search_words
          : getValues().search_word,
        page,
        priceSort
      ),
    onSuccess: (res) => setData([...new Set([...res.data])]),
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const { data: inputsFavorites } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getInputsFavorites(),
    initialData: [],
    enabled: isAuth,
  });

  const handlePage = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    refetch();
  }, [page]);

  if (error) {
    return <div className="flex justify-center items-center">error</div>;
  }

  return (
    <>
      <Helmet>
        ‍<title>عروض مدخلات الإنتاج - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="عروض مدخلات الإنتاج - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      {showFilters && (
        <FillterModal
          categories={categories}
          crop={crop}
          onSubmit={refetch}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          states={states}
          setState={setState}
          state={state}
          name="المدخل"
        />
      )}
      <AnimatePresence>
        {showModal && (
          <DetailsModal
            offer={input}
            cities_data={cities_data}
            markets_data={markets_data}
            setShowContactModal={setShowContactModal}
            setShowOrderModal={setShowOrderModal}
            setShowModal={setShowModal}
            states={states}
            favoriteOffers={inputsFavorites}
            type="متوفر"
          />
        )}
        {showContactModal && (
          <ContactModal
            offer={input}
            setShowContactModal={setShowContactModal}
          />
        )}
        {showOrderModal && (
          <PlaceOrderModal
            item={input}
            setShowOrderModal={setShowOrderModal}
            tradeType={"Demand"}
            negotiationType={"Input"}
          />
        )}
      </AnimatePresence>
      <div className="grid w-11/12 grid-cols-2 gap-5 mt-10 lg:w-[81rem] lg:gap-2 lg:grid-flow-row lg:grid-cols-5 mx-6 lg:mx-0 lg:px-20">
        <SmallSearch
          page={4}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          categories={categories}
          states={states}
          crop={crop}
          state={state}
          setState={setState}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          text="إضافة عرض"
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
        />
        {/* lg search */}
        <LgSearch
          page={4}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          setShowFilters={setShowFilters}
          text="إضافة مدخل"
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
        />
        {data.data?.length === 0 ? (
          <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
            <div className="font-bold mx-auto">
              <img src={notFound} />
            </div>
            <div className="h-6"></div>
            <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
              عذراً لا توجد منتجات{" "}
            </div>
          </div>
        ) : (
          data?.map((item) => (
            <InputItem
              key={item.id}
              item={item}
              getInput={(id) => getInput(id)}
              editLink={`/editInput/${item.id}`}
              favoriteInputs={inputsFavorites}
            />
          ))
        )}
        {isFetching && (
          <>
            {[...Array(7).keys()].map((e, i) => (
              <Skelton key={i} />
            ))}
          </>
        )}
      </div>
      <div className="text-center">
        {!isFetching && inputs.pageCount > inputs.page && (
          <button
            onClick={handlePage}
            disabled={inputs.pageCount < inputs.page || isFetching}
            className="bg-primary mt-8 text-white rounded-full py-1 px-4 hover:bg-[#42cf6a] hover:scale-105 transition disabled:opacity-50 disabled:animate-pulse"
          >
            عرض المزيد
          </button>
        )}
      </div>
    </>
  );
}

export default InputsOffers;
